import React from 'react';
import styles from './index.module.scss'

type Props = {
  children: any;
  type: 'default' | 'success' | 'simple' | 'default_transparent';
  onClick?: () => void
}

const Button = (props: Props) => {
  return (
    <button onClick={props.onClick} className={`${styles.btn} ${styles[props.type]}`}>{props.children}</button>
  );
}

export default Button;
